import React, { PureComponent } from 'react';
import Select, { selectType } from 'Components/Select';
import { ROLES } from 'constants/roles';

export default class SummaryGeneralInfo extends PureComponent {
  _getYearsList = () => {
    const {currentYear} = this.props;

    let list = [];
    for (let i = -1; i < 20; i++) {
      list.push(currentYear - i);
    }

    return list;
  };

  render() {
    const {user, currentYear, year, handleRoleChange, handleYearSelect} = this.props;

    if (
      !user.isInternal() &&
      (user.activeRole.serverName === ROLES.OIL_MANUFACTURER.serverName ||
        user.activeRole.serverName === ROLES.OIL_BRANDER.serverName)
    )
      return (
        <section>
          <header className="ect-header _height_120">
            <div className="ect-header__text _color_dark_blue_2 _width_pc_100 _text_align_center">
              Welcome to NMMA Oil Certification!
            </div>
          </header>
        </section>
      );

    const {oilRoles, isTwoOilRolesAvailable} = (() => {
      const oilRoles = [];
      if (user.isOilManufacturer()) oilRoles.push({name: 'Oil formulator', value: ROLES.OIL_MANUFACTURER.serverName});
      if (user.isOilBrander()) oilRoles.push({name: 'Oil brander', value: ROLES.OIL_BRANDER.serverName});

      const isTwoOilRolesAvailable = user.getRoleName() === ROLES.OIL_MANUFACTURER.readableName && oilRoles.length === 2;

      return {oilRoles, isTwoOilRolesAvailable};
    })();

    return (
      <section className='scene_section scene_section_two-columns  _padding_top_15 _padding_bottom_20'>
        <header>
          {user.activeRole.serverName === ROLES.OIL_BRANDER.serverName ||
          user.activeRole.serverName === ROLES.OIL_MANUFACTURER.serverName
            ? 'General Info'
            : 'Model Year'}
        </header>
        <Select
          isSlave
          withoutSearch
          mainWrapperClassName={isTwoOilRolesAvailable ? '_margin_top_34' : ''}
          selectionList={this._getYearsList()}
          defaultItem={year ? year.toString() : ''}
          type={selectType.primary}
          label={
            <React.Fragment>
              {this.yearSelectHeader}
              <div className='select__sub-label'>{this.modelYearReminder}</div>
            </React.Fragment>
          }
          labelClassName='_flex'
          placeholder={'Type year or pick-up one'}
          handleSelect={handleYearSelect}
          isLoading={!currentYear}
        />
        {isTwoOilRolesAvailable && (
          <Select
            withoutSearch
            selectionList={oilRoles}
            itemNameIndicator='name'
            defaultItem={oilRoles[0]}
            type={selectType.primary}
            label='Manufacturer role'
            handleSelect={handleRoleChange}
          />
        )}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/SummaryScene/GeneralInfo.jsx